import { render, staticRenderFns } from "./OverviewPanels.vue?vue&type=template&id=21705434&scoped=true"
import script from "./OverviewPanels.vue?vue&type=script&lang=js"
export * from "./OverviewPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21705434",
  null
  
)

export default component.exports